import * as animationData from '@/assets/animations/loadingDotsLink.json';
import AnimationWrapper from '../AnimationWrapper';
import { AnimationProps } from '../types';

const LoadingDotsLink = (props: AnimationProps) => {
  const animationProps = { ...props, animationData };
  return <AnimationWrapper {...animationProps} />;
};

export default LoadingDotsLink;
